<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .message {
    display: flex;
    flex-direction: column;

    padding: utils.in_rem(20px);
    gap: utils.in_rem(20px);

    background-color: colors.get(interfaceWhite);
    border-radius: 8px;

    height: 100%;
    overflow: auto;

    .message-headers {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(4px);

      @include mixins.caption();
      @include colors.color(black_90);
    }

    .message-content {
      @include mixins.body3();
      @include colors.color(black_90);
      white-space: pre-wrap;

      .highlight {
        @include colors.background-color(aiSurfacePurple);
      }
    }
  }
</style>

<script>
  import { todosModalItemStore } from "../stores";
  import { highlightTriggerText } from "./utils";

  let message = $derived($todosModalItemStore.message);
  let trigger = $derived($todosModalItemStore.trigger);
</script>

{#if message?.content}
  SourceWhale AI found the following message from your sent items:
  <div class="message">
    <div class="message-headers">
      {#if message.to}
        <div>
          <strong>To:</strong>
          {message.to}
        </div>
      {/if}

      {#if message.subject}
        <div>
          <strong>Subject:</strong>
          {message.subject}
        </div>
      {/if}
    </div>
    <div class="message-content">
      {#each highlightTriggerText(message.content, [trigger]) as part}
        <span class:highlight={part.highlight}>
          {part.text}
        </span>
      {/each}
    </div>
  </div>
{:else}
  We could not display the message content that created this task.
{/if}
